module.exports = __webpack_public_path__ + "img/trailer_preview.fb05411.webp";